import {EvFormGroup} from '../../form/EvFormGroup';
import {EvDatePickerField} from '../../form/EvDatepickerField';
import {EvButton} from '../../form/EvButton';
import {useForm} from '@tanstack/react-form';
import {format} from 'date-fns';
import {CalculationGoldFormUpsertRequest, CalculationGoldListElement} from './calculation-gold.models';
import {EvNumberInputField} from '../../form/EvNumberInputField';
import {clsx} from 'clsx';
import {Money} from '../../../common/money/Money';
import {ReactNode} from 'react';
import {useCalculationGoldCreateMutation} from './calculation-gold-create-mutation';
import {useCalculationGoldUpdateMutation} from './use-calculation-gold-update-mutation';
import {useAxiosError} from '../../errorhandling/useAxiosError';

interface Props {
  update: CalculationGoldListElement | null;
  months?: number | null;
  deselected?: () => void;
  children?: ReactNode;
}

export function CalculationGoldForm(props: Props) {
  const now = new Date();
  const createMutation = useCalculationGoldCreateMutation();
  const updateMutation = useCalculationGoldUpdateMutation({selected: props.update});
  const currentMutation = !props.update ? createMutation : updateMutation;
  const form = useForm({
    defaultValues: {
      'price': props.update?.price ?? 0,
      'date': props.update?.date ?? format(now, 'dd.MM.yyyy'),
      'months': props.months ?? null,
      'entryType': 3,
    } as CalculationGoldFormUpsertRequest,
    onSubmit: ({value, formApi}) => {
      currentMutation.mutate(
        value,
        {
          onSuccess: () => {
            formApi.reset({
              'price': 0,
              'date': format(now, 'dd.MM.yyyy'),
              'months': props.months ?? null,
              'entryType': 3,
            });

            if (!!props.deselected) {
              props.deselected();
            }
          },
        });
    },
  });
  const error = useAxiosError(currentMutation.error);

  return <div>
    <form onSubmit={async (e) => {
      e.preventDefault();
      await form.handleSubmit();
    }}>
      {props.children}
      <EvFormGroup nameLabel="Datum" nameValue="create_date" columnPartsLabel={3} columnParts={9}>
        <form.Field name="date">
          {(field) =>
            <EvDatePickerField id="create_date"
                               field={field}
                               className={clsx(
                                 {
                                   'red_alert': !!error?.validation?.errors?.date || !!error?.existing,
                                 },
                                 'text-right',
                               )}
                               disabled={!!props.update}/>}
        </form.Field>
      </EvFormGroup>

      <EvFormGroup nameLabel="Preis" nameValue="create_price" columnPartsLabel={3} columnParts={9}>
        <form.Field name="price">
          {(field) =>
            <EvNumberInputField id="create_price"
                                field={field}
                                className={clsx(
                                  {
                                    'red_alert': !!error?.validation?.errors?.price,
                                  },
                                  'text-right',
                                )}
                                numberType="decimal"
                                decimals={2}
                                numberFormatFunction={Money.stringify}/>}
        </form.Field>
      </EvFormGroup>
      <div className="row">
        <div className="col-sm-12 text-right">
          <EvButton type="submit" variant="success" disabled={currentMutation.isPending}>Speichern</EvButton>
        </div>
      </div>
    </form>
  </div>;
}
